import { SpotCrossSelection } from './types'

export const rejectOrder = (payload: string) =>
  ({ type: 'lastLook.rejectOrder', payload } as const)
export type RejectOrderAction = ReturnType<typeof rejectOrder>

export const confirmOrder = (
  id: string,
  spotCrossSelection: SpotCrossSelection
) =>
  ({
    type: 'lastLook.confirmOrder',
    payload: { id, spotCrossSelection }
  } as const)
export type ConfirmOrderAction = ReturnType<typeof confirmOrder>

export const rejectOrderFailure = (payload: number) =>
  ({ type: 'lastLook.rejectOrderFailure', error: true, payload } as const)
export type RejectOrderFailureAction = ReturnType<typeof rejectOrderFailure>

export const confirmOrderFailure = (payload: number) =>
  ({ type: 'lastLook.confirmOrderFailure', error: true, payload } as const)
export type ConfirmOrderFailureAction = ReturnType<typeof confirmOrderFailure>

export type LastLookAction =
  | ConfirmOrderAction
  | ConfirmOrderFailureAction
  | RejectOrderAction
  | RejectOrderFailureAction
